module.exports = __webpack_public_path__ + "fonts/iranyekanwebregularfanum.f01e9ae.woff";